import { DocumentFormat } from 'src/types/DocumentSettings';
import { BlockTypesEnum } from '../types/models/Block';

/**
 * When documents are created with the AI alignment tool, this configuration
 * specifies the default ordering of the blocks to be used.
 *
 * This is a cleaner specification of documents than DOCUMENT_TEMPLATES and
 * should be preferred going forward.
 */
export const DOCUMENT_STARTERS: {
  id: string;
  writingPlanId: string;
  format: DocumentFormat;
  pages: {
    blocks: {
      typeId: BlockTypesEnum;
    }[]
  }[]
}[] = [
  {
    id: 'persuasion-doc',
    writingPlanId: 'melelcon-persuasion',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.Hook },
        { typeId: BlockTypesEnum.Background },
        { typeId: BlockTypesEnum.MainIdea },
        { typeId: BlockTypesEnum.EvidenceAndLinks },
        { typeId: BlockTypesEnum.ConcludingParagraph },
      ],
    }],
  },
  {
    id: 'personal-narrative-doc',
    writingPlanId: 'personal-narrative',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.Introduction },
        { typeId: BlockTypesEnum.PeopleAndSetting },
        { typeId: BlockTypesEnum.Details },
        { typeId: BlockTypesEnum.Conclusion },
      ],
    }],
  },
  {
    id: 'news-article-doc',
    writingPlanId: 'news-article',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.Lead },
        { typeId: BlockTypesEnum.MainIdea },
        { typeId: BlockTypesEnum.SupportingDetails },
        { typeId: BlockTypesEnum.Conclusion },
      ],
    }],
  },
  {
    id: 'story-doc',
    writingPlanId: 'story',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.SettingAndCharacters },
        { typeId: BlockTypesEnum.ProblemOrGoal },
        { typeId: BlockTypesEnum.Attempts },
        { typeId: BlockTypesEnum.StorySolution },
        { typeId: BlockTypesEnum.Resolution },
      ],
    }],
  },
  {
    id: 'op-ed-doc',
    writingPlanId: 'op-ed',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.Introduction },
        { typeId: BlockTypesEnum.ClaimOrOpinion },
        { typeId: BlockTypesEnum.Evidence },
        { typeId: BlockTypesEnum.Conclusion },
      ],
    }],
  },
  {
    id: 'book-review-doc',
    writingPlanId: 'book-review',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.Introduction },
        { typeId: BlockTypesEnum.MainIdea },
        { typeId: BlockTypesEnum.ClaimOrOpinion },
        { typeId: BlockTypesEnum.Conclusion },
      ],
    }],
  },
  {
    id: 'restaurant-review-doc',
    writingPlanId: 'restaurant-review',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.Introduction },
        { typeId: BlockTypesEnum.MainIdea },
        { typeId: BlockTypesEnum.ClaimOrOpinion },
        { typeId: BlockTypesEnum.Conclusion },
      ],
    }],
  },
  {
    id: 'sequence-doc',
    writingPlanId: 'sequence',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.Introduction },
        { typeId: BlockTypesEnum.Event },
        { typeId: BlockTypesEnum.Conclusion },
      ],
    }],
  },
  {
    id: 'cause-effect-doc',
    writingPlanId: 'cause-effect',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.Introduction },
        { typeId: BlockTypesEnum.Cause },
        { typeId: BlockTypesEnum.Effect },
        { typeId: BlockTypesEnum.Conclusion },
      ],
    }],
  },
  {
    id: 'compare-contrast-doc',
    writingPlanId: 'compare-contrast',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.Introduction },
        { typeId: BlockTypesEnum.Compare },
        { typeId: BlockTypesEnum.Contrast },
        { typeId: BlockTypesEnum.Conclusion },
      ],
    }],
  },
  {
    id: 'problem-solution-doc',
    writingPlanId: 'problem-solution',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.Introduction },
        { typeId: BlockTypesEnum.Problem },
        { typeId: BlockTypesEnum.Solution },
        { typeId: BlockTypesEnum.Conclusion },
      ],
    }],
  },
  {
    id: 'description-doc',
    writingPlanId: 'description',
    format: DocumentFormat.DOC,
    pages: [{
      blocks: [
        { typeId: BlockTypesEnum.Title },
        { typeId: BlockTypesEnum.MainIdea },
        { typeId: BlockTypesEnum.SupportingDetails },
        { typeId: BlockTypesEnum.Conclusion },
      ],
    }],
  },
];
